import { Clock3 } from "lucide-react";
import type { WidgetDef } from "../types";
import { ClockGlance, ClockView } from "./ClockWidget";
import { ClockSettings } from "./ClockSettings";
import { defaultClockConfig, parseClockConfig, type ClockConfig } from "./config";

export const clockWidget: WidgetDef<ClockConfig> = {
  type: "clock",
  icon: Clock3,
  title: "clock.title",
  description: "clock.description",
  sizes: ["s", "m", "l"],
  defaultSize: "m",
  defaultConfig: defaultClockConfig,
  parseConfig: parseClockConfig,
  available: (me) => me.role !== "carrier",
  View: ClockView,
  Glance: ClockGlance,
  Settings: ClockSettings,
};
